// Italian (it) — EU MDR submission language.
// Covers the visitor-facing eIFU portal strings only; the admin console is not
// localized. Missing keys fall back to English (see src/i18n.js).
const it = {
  'show all manuals': 'mostra tutti i manuali',
  eifuPortalIntro:
    'Consulta e scarica le istruzioni per l’uso elettroniche (eIFU) del software per dispositivi medici RAY.',
  'Checking the latest documents.': 'Verifica dei documenti più recenti in corso.',
  'There are no manuals to display.': 'Non ci sono manuali da visualizzare.',
  Manuals: 'Manuali',
  'Product Name': 'Nome del prodotto',
  Language: 'Lingua',
  'Document Name': 'Nome del documento',
  Product: 'Prodotto',
  Revision: 'Revisione',
  Document: 'Documento',
  Published: 'Pubblicato',
  Country: 'Paese',
  'All countries': 'Tutti i paesi',
  Search: 'Cerca',
  'No results': 'Nessun risultato',
  'appManuals.downloadHelpText':
    'I file scaricati possono essere visualizzati tramite un browser internet o un software di lettura PDF.',
  'appManuals.systemRequirements':
    'Requisiti di sistema: CPU Intel® Core™ i3 o superiore, 4 GB di memoria o più, 100 MB o più di spazio di archiviazione libero per il salvataggio del PDF.',
  'criticalNotice.badge': 'Avviso importante',
  'criticalNotice.close': 'Chiudi',
};

export default it;
